import { actions as deviceActions } from 'ducks/devices';
import icons from 'utils/ui/icons';

const DANGER_COLOR = '#B94A48';

export default (device, submitting, dispatch) => ({
    color: DANGER_COLOR,
    confirmationHeader: 'Deactivate Device',
    confirmationText: `Deactivate "${device.name}"? All of its child devices will also be deactivated and their data acquisition will stop. This cannot be undone from the UI. Are you sure?`,
    icon: icons.deactivate,
    onClick: () => dispatch(deviceActions.deactivate(device.id)),
    submitting,
    tooltip: 'Deactivate Device'
});
